import script from "./ClientField.vue?vue&type=script&lang=ts&setup=true"
export * from "./ClientField.vue?vue&type=script&lang=ts&setup=true"

import "./ClientField.vue?vue&type=style&index=0&id=d8ea48d2&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8ea48d2"]])

export default __exports__